import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Link } from "wouter";
import { Badge } from "../ui/badge";
import { cn } from "@/lib/utils";

const Hero = () => {
  return (
    <section 
      className={cn(
        "relative bg-white dark:bg-white overflow-hidden",
        "py-8 sm:py-16 md:py-24 lg:py-32 px-4"
      )}
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-8 sm:gap-12 pt-8 sm:pt-16">
        <div className="flex flex-col items-center gap-4 sm:gap-6 text-center lg:gap-12">
          {/* Badge */}
          <Badge variant="outline" className="animate-fade-in gap-1 sm:gap-2 text-xs sm:text-sm px-3 py-1 !bg-white !border-gray-200">
            <span className="text-gray-600 dark:text-gray-600">Contract & Client Management</span>
            <a href="/#features" className="flex items-center gap-1 text-blue-600 hover:text-blue-700 dark:text-blue-600 dark:hover:text-blue-700">
              <span className="hidden sm:inline">See features</span>
              <span className="sm:hidden">Features</span>
              <ArrowRight className="h-3 w-3" />
            </a>
          </Badge>

          {/* Title */}
          <h1 className="relative z-10 inline-block animate-fade-in bg-gradient-to-r from-gray-900 to-blue-600 bg-clip-text text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold leading-tight text-transparent drop-shadow-2xl opacity-0 animation-delay-200 px-2 sm:px-0">
            Manage your consulting business <span className="text-blue-600">effortlessly</span>
          </h1>

          {/* Description */}
          <p className="text-base sm:text-lg md:text-xl relative z-10 max-w-[90%] sm:max-w-[600px] animate-fade-in font-medium text-gray-600 dark:text-gray-600 opacity-0 animation-delay-400 px-4 sm:px-0">
            Track time, create professional invoices, and manage client relationships - all in one platform designed for freelancers and consultants.
          </p>

          {/* Key Benefits */}
          <div className="relative z-10 animate-fade-in opacity-0 animation-delay-500">
            <div className="flex flex-wrap justify-center gap-2 text-xs sm:text-sm text-gray-600 dark:text-gray-600 max-w-[90%] sm:max-w-[500px] px-4 sm:px-0">
              <span className="bg-gray-100 dark:bg-gray-100 px-2 sm:px-3 py-1 rounded-full">Time Tracking</span>
              <span className="bg-gray-100 dark:bg-gray-100 px-2 sm:px-3 py-1 rounded-full">Invoicing</span>
              <span className="bg-gray-100 dark:bg-gray-100 px-2 sm:px-3 py-1 rounded-full">Client Management</span>
              <span className="bg-gray-100 dark:bg-gray-100 px-2 sm:px-3 py-1 rounded-full">Analytics</span>
            </div>
          </div>

          {/* Actions */}
          <div className="relative z-10 flex flex-col sm:flex-row animate-fade-in justify-center gap-3 sm:gap-4 opacity-0 animation-delay-600 w-full sm:w-auto px-4 sm:px-0">
            <Link href="/login?tab=register">
              <Button size="lg" className="!bg-blue-600 hover:!bg-blue-700 !text-white !border-0 w-full sm:w-auto">
                Get Started
                <ArrowRight className="ml-1 h-4 w-4 sm:h-5 sm:w-5" />
              </Button>
            </Link>
            <Link href="/#features">
              <Button variant="outline" size="lg" className="!bg-white !border-2 !border-gray-300 !text-gray-700 hover:!bg-gray-50 hover:!border-gray-400 w-full sm:w-auto">
                See How It Works
              </Button>
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="relative z-10 animate-fade-in opacity-0 animation-delay-700 px-4 sm:px-0">
            <div className="text-xs sm:text-sm text-gray-500 dark:text-gray-500 flex flex-col gap-2 sm:flex-row sm:gap-6">
              <span className="flex items-center justify-center">✓ Start Free Today</span>
              <span className="flex items-center justify-center">✓ No credit card required</span>
              <span className="flex items-center justify-center">✓ Cancel anytime</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 